import type { ChatSource } from '@archie/api-shared';

/**
 * Stable key for a ChatSource — matches the dedup key the API uses on the
 * server side, so client and server agree on identity.
 */
export const sourceKey = (s: ChatSource): string =>
  s.kind === 'web' ? `web:${s.url}` : `kb:${s.documentId ?? ''}|${s.sourceId ?? ''}`;
